import React from 'react';
import { Box } from '@mui/material';

export default function ResponsiveAdminPage({
    children,
    maxWidth = 1500,
    pb = { xs: 3, md: 4 },
    pt = 0,
    sx = {},
}) {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth,
                mx: 'auto',
                pt,
                pb,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
